// This is a custom UI for our 'between' or number range
// filter. It uses two number boxes and filters rows to

import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useAsyncDebounce } from "react-table";
import DatePicker, { ReactDatePickerCustomHeaderProps } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

// using https://github.com/Hacker0x01/react-datepicker
// https://reactdatepicker.com/

//https://reactdatepicker.com/#example-custom-day

const range = (start: number, stop: number, step: number) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

const years = range(1990, new Date().getFullYear(), 1);
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const getNextYearValue = (currentYear: number, currentMonth: number) =>
  currentMonth === 11 ? currentYear + 1 : currentYear;

const getNextMonthValue = (currentMonth: number) =>
  currentMonth === 11 ? 0 : currentMonth + 1;

const CurrentMonthHeader = ({
  monthDate,
  date,
  customHeaderCount,
  changeYear,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => (
  <div>
    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
      {"<"}
    </button>
    <select
      value={months[date.getMonth()]}
      onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
    >
      {months.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
    <select
      value={date.getFullYear()}
      onChange={({ target: { value } }) => changeYear(parseInt(value, 10))}
    >
      {years.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
      {">"}
    </button>
  </div>
);

const NextMonthHeader = ({
  monthDate,
  date,
  customHeaderCount,
  changeYear,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => (
  <div>
    <label>
      {months[getNextMonthValue(date.getMonth())] +
        " " +
        getNextYearValue(date.getFullYear(), date.getMonth())}
    </label>
  </div>
);

const CustomDateRangeHeader = ({
  monthDate,
  date,
  customHeaderCount,
  changeYear,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => (
  <div
    style={{
      margin: 10,
      display: "flex",
      justifyContent: "center",
    }}
  >
    {customHeaderCount === 0 && (
      <CurrentMonthHeader
        date={date}
        monthDate={monthDate}
        changeMonth={changeMonth}
        increaseMonth={increaseMonth}
        decreaseMonth={decreaseMonth}
        changeYear={changeYear}
        increaseYear={increaseYear}
        decreaseYear={decreaseYear}
        nextMonthButtonDisabled={nextMonthButtonDisabled}
        nextYearButtonDisabled={nextYearButtonDisabled}
        prevMonthButtonDisabled={prevMonthButtonDisabled}
        prevYearButtonDisabled={prevYearButtonDisabled}
        customHeaderCount={customHeaderCount}
      />
    )}
    {customHeaderCount === 1 && (
      <NextMonthHeader
        date={date}
        monthDate={monthDate}
        changeMonth={changeMonth}
        increaseMonth={increaseMonth}
        decreaseMonth={decreaseMonth}
        changeYear={changeYear}
        increaseYear={increaseYear}
        decreaseYear={decreaseYear}
        nextMonthButtonDisabled={nextMonthButtonDisabled}
        nextYearButtonDisabled={nextYearButtonDisabled}
        prevMonthButtonDisabled={prevMonthButtonDisabled}
        prevYearButtonDisabled={prevYearButtonDisabled}
        customHeaderCount={customHeaderCount}
      />
    )}
  </div>
);

function DateRangeColumnFilter({
  column: { filterValue = [], preFilteredRows, setFilter, id },
}: {
  column: any;
}) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const onDateChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setFilter([start, end]);
  };

  return (
    <div className="d-flex mt-2">
      <DatePicker
        renderCustomHeader={CustomDateRangeHeader}
        className="form-control"
        selected={startDate}
        onChange={onDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        monthsShown={1}
        isClearable
        locale="en-GB"
        dateFormat={"dd/MM/yyyy"}
        shouldCloseOnSelect={false}
      />
    </div>
  );
}

export { DateRangeColumnFilter };
